@if (isReportLoading$ | async) {
  <nk-spinner display="inline" [attr.data-cy]="'global-report-loading'"></nk-spinner>
}
@if (screeningEntitiesInputParams(); as screeningEntitiesInputParams) {
  @if (screeningEntitiesInputParams.companyUuid; as companyUuid) {
    <div class="report-view" [@.disabled]="animationsDisabled">
      @if (reportTitlePageData(); as reportTitlePageData) {
        <nk-report-title-page
          class="page-break-after d-flex"
          [reportTitlePageData]="reportTitlePageData"></nk-report-title-page>
      }
      <div class="page-break-after" [attr.data-cy]="'company-information'">
        <nk-screening-report-company-base-info [companyUuid]="companyUuid"></nk-screening-report-company-base-info>
      </div>
      <div class="page-break-after" [attr.data-cy]="'monitoring-connections'">
        <nk-monitoring-connection-card-list [collapsibleDetails]="false"></nk-monitoring-connection-card-list>
      </div>
      <div class="page-break-after" [attr.data-cy]="'-screening-cases'">
        <nk-screening-case-card-list [collapsibleDetails]="false"> </nk-screening-case-card-list>
      </div>
      <div class="page-break-after" [attr.data-cy]="'company-legal-right'">
        <nk-screening-report-company-legal-right></nk-screening-report-company-legal-right>
      </div>
      <div class="page-break-after" [attr.data-cy]="'company-legal-right'">
        <nk-screening-report-company-ownership [companyUuid]="companyUuid"></nk-screening-report-company-ownership>
      </div>
      <div class="page-break-after" [attr.data-cy]="'company-company-roles'">
        <nk-screening-report-company-roles></nk-screening-report-company-roles>
      </div>
    </div>
  }
}
